
import { defineComponent, onMounted, ref, computed, watchEffect } from "vue";
import { useI18n } from "vue-i18n/index";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { version } from "@/core/helpers/documentation";
// import { asideMenuIcons } from "@/core/helpers/config";
import objectPath from "object-path";

export default defineComponent({
  name: "kt-menu",
  components: {},
  setup() {
    const asideMenuIcons = "font";
    const store = useStore();
    const user = computed(() => store.getters.getUser);
    const MainMenu = [
      {
        heading: "dashboard",
        route: "/dashboard",
        svgIcon: "media/icons/duotune/general/gen001.svg",
        fontIcon: "bi-bar-chart",
      },
      {
        heading: "expert-profile",
        route: "/expert-profile",
        svgIcon: "media/icons/duotune/general/gen019.svg",
        fontIcon: "bi-person",
      },
      {
        heading: "investor-profile",
        route: "/investor-profile",
        svgIcon: "media/icons/duotune/general/gen019.svg",
        fontIcon: "bi-person",
      },
      {
        heading: "find-experts",
        route: "/find-experts",
        svgIcon: "media/icons/duotune/general/gen019.svg",
        fontIcon: "bi-search",
      },
      {
        heading: "find-investment-opportunities",
        route: "/find-investment-opportunities",
        svgIcon: "media/icons/duotune/general/gen019.svg",
        fontIcon: "bi-search",
      },
      {
        heading: "matched-investment-opportunities",
        route: "/matched-investment-opportunities",
        svgIcon: "media/icons/duotune/general/gen019.svg",
        fontIcon: "bi-clipboard-check",
      },
      {
        heading: "addRole",
        route: "/add-role",
        svgIcon: "media/icons/duotune/ecommerce/ecm002.svg",
        fontIcon: "bi-person-plus",
      },
      {
        heading: "investment-opportunities",
        route: "/investment-opportunities",
        svgIcon: "media/icons/duotune/ecommerce/ecm002.svg",
        fontIcon: "bi-building",
      },
      {
        heading: "connected-experts",
        route: "/connected-experts",
        svgIcon: "media/icons/duotune/general/gen019.svg",
        fontIcon: "bi-person-check-fill",
      },
      {
        heading: "connected-founders",
        route: "/connected-founders",
        svgIcon: "media/icons/duotune/general/gen019.svg",
        fontIcon: "bi-person-check-fill",
      },
      {
        heading: "connected-investment-opportunities",
        route: "/connected-investment-opportunities",
        svgIcon: "media/icons/duotune/general/gen019.svg",
        fontIcon: "bi-diagram-3",
      },
      {
        heading: "subscription",
        route: "/subscription",
        svgIcon: "media/icons/duotune/general/gen019.svg",
        fontIcon: "bi-currency-pound",
      },
    ];
    let MainMenuTemp = [...MainMenu];
    let MainMenuConfig = ref(MainMenuTemp);
    const filterItems = () => {
      MainMenuTemp = [...MainMenu];
      MainMenuTemp = MainMenuTemp.filter((config) => {
        if (
          (config.heading == "expert-profile" ||
            config.heading == "connected-founders" ||
            config.heading == "subscription") &&
          !(user.value.expert instanceof Array) &&
          user.value.expert &&
          user.value?.userRoles?.some(
            (role) => role.name.toLowerCase() == "expert"
          )
        ) {
          return true;
        } else if (
          config.heading == "connected-experts" &&
          user.value?.userRoles?.some(
                (role) => role.name.toLowerCase() == "founder"
              )
        ) {
          return true;
        } else if (
          config.heading == "dashboard" &&
          ((!(user.value?.investor instanceof Array) &&
            user.value.investor &&
            user.value?.userRoles?.some(
              (role) => role.name.toLowerCase() == "investor"
            )) ||
            (
              user.value?.userRoles?.some(
                (role) => role.name.toLowerCase() == "founder"
              )) ||
            (!(user.value.expert instanceof Array) &&
              user.value.expert &&
              user.value?.userRoles?.some(
                (role) => role.name.toLowerCase() == "expert"
              )))
        ) {
          return true;
        } else if (
          (config.heading == "investor-profile" ||
            config.heading == "find-investment-opportunities" ||
            config.heading == "matched-investment-opportunities" ||
            config.heading == "connected-investment-opportunities") &&
          !(user.value?.investor instanceof Array) &&
          user.value.investor &&
          user.value?.userRoles?.some(
            (role) => role.name.toLowerCase() == "investor"
          )
        ) {
          return true;
        } else if (
          config.heading == "find-experts" &&
          user.value?.userRoles?.some(
                (role) => role.name.toLowerCase() == "founder"
              )
        ) {
          return true;
        } else if (
          config.heading == "investment-opportunities" &&
          user.value?.userRoles?.some(
                (role) => role.name.toLowerCase() == "founder"
              )
        ) {
          return true;
        }
        else if (
          (config.heading == "addUsers" ||
          config.heading == "business-plans") &&
          user.value?.isBusiness == 1
        ) {
          return true;
        }
        else if (
          config.heading !== "expert-profile" &&
          config.heading !== "investor-profile" &&
          config.heading !== "founder-profile" &&
          config.heading !== "find-experts" &&
          config.heading !== "investment-opportunities" &&
          config.heading !== "find-investment-opportunities" &&
          config.heading !== "matched-investment-opportunities" &&
          config.heading !== "dashboard" &&
          config.heading !== "connected-experts" &&
          config.heading !== "connected-investment-opportunities" &&
          config.heading !== "connected-founders" &&
          config.heading !== "subscription" &&
          config.heading !== "business-plans" &&
          config.heading !== "addUsers"
        ) {
          return true;
        } else return false;
      });
      MainMenuConfig.value = MainMenuTemp;
    };
    watchEffect(() => {
      if (user.value) filterItems();
    });
    filterItems();
    const { t, te } = useI18n();
    const route = useRoute();
    const scrollElRef = ref<null | HTMLElement>(null);

    onMounted(() => {
      if (scrollElRef.value) {
        scrollElRef.value.scrollTop = 0;
      }
    });

    const translate = (text) => {
      if (te(text)) {
        return t(text);
      } else {
        return text;
      }
    };

    const hasActiveChildren = (match) => {
      return route.path.indexOf(match) !== -1;
    };

    return {
      hasActiveChildren,
      MainMenuConfig,
      asideMenuIcons,
      version,
      translate,
      user
    };
  },
});
